import React, { ReactNode } from "react";

import * as S from "./Invoice.styles";

interface TableWrapperProps {
  headers: string[];
  children?: ReactNode;
  padding?: string;
}

const TableWrapper = ({ headers, children, padding }: TableWrapperProps) => {
  return (
    <S.Table padding={padding}>
      <S.TableHead>
        <S.TR>
          {headers?.map(header => (
            <S.TableHeader key={header}>{header}</S.TableHeader>
          ))}
        </S.TR>
      </S.TableHead>
      <tbody>{children}</tbody>
    </S.Table>
  );
};

export default TableWrapper;
